import { storyblokEditable } from "@storyblok/react"
import { Trustpilot } from "@/features/trustpilot"
import { type SbBlokTrustpilot } from "../types"

interface DynamicTrustpilotProps {
    blok: SbBlokTrustpilot
}

export function DynamicTrustpilot({ blok }: DynamicTrustpilotProps) {
    return (
        <Trustpilot
            {...storyblokEditable(blok)}
            templateId={blok.templateId}
            businessUnitId={blok.businessUnitId}
            height={blok.height}
            width={blok.width}
            theme={blok.theme}
            tags={blok.tags}
            reviewLanguages={blok.reviewLanguages}
            stars={blok.stars}
        />
    )
}

export default DynamicTrustpilot
